<template>
  <div class="column justify-center items-center gif-loading loading-vehicle">
    <img :src="src" alt="Loading" />
  </div>
</template>

<script>
export default {
  name: 'LoadingVehicle',
  computed: {
    src() {
      return `${process.env.BASE_URL}assets/images/animation_transparent.gif`;
    }
  }
};
</script>

<style lang="sass" scoped>
.loading-vehicle > img
  width: 100%
@media (min-width:736px)
  .loading-vehicle > img
    width: 450px
    height: 475px

.gif-loading
  padding-bottom: 100px
  margin-top: -30px
</style>
